<template>
  <BbSelectList v-model="selectedValue" :label="fieldConfig.name" class="filters-dropdown" size="small" width="220px">
    <template #default>
      <BbSelectListItem
        v-for="(item, index) in fieldConfig.optionList"
        :key="index"
        :label="item.label"
        :value="item.value"
        size="small"
      >
        {{ item.label }}
      </BbSelectListItem>
    </template>
  </BbSelectList>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    filtersConfig: {
      type: Array,
      default: () => [],
      required: true,
    },
    fieldConfig: {
      type: Object,
      default: () => {},
      required: true,
    },
    values: {
      type: Object,
      default: () => {},
      required: true,
    },
  },

  setup(props, { emit }) {
    const selectedValue = computed({
      get: () => props.values[props.fieldConfig.id],
      set: (val) => emit('change', { value: val, id: props.fieldConfig.id }),
    });

    return {
      selectedValue,
    };
  },
};
</script>
<style scope lang="scss">
.filters-dropdown {
  .filters-dropdown {
    .bb-select-list__dropdown .el-select-dropdown .el-select-dropdown__item:first-child {
      font-style: italic;
    }
  }
}
</style>
